export default __webpack_public_path__ + "76c2b574bb525eb7ee61c4e188d9416f.svg";